import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared axios instance. withCredentials ensures the HttpOnly admin cookie
// is sent on same-origin requests (admin endpoints). Public endpoints ignore it.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// FastAPI 422 returns an array of {msg} objects; never render that directly.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
